import { render, staticRenderFns } from "./safeWorkPermitStateByYear.vue?vue&type=template&id=5f7a061c"
import script from "./safeWorkPermitStateByYear.vue?vue&type=script&lang=js"
export * from "./safeWorkPermitStateByYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7a061c')) {
      api.createRecord('5f7a061c', component.options)
    } else {
      api.reload('5f7a061c', component.options)
    }
    module.hot.accept("./safeWorkPermitStateByYear.vue?vue&type=template&id=5f7a061c", function () {
      api.rerender('5f7a061c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/state/safeWorkPermitStateByYear.vue"
export default component.exports